import React from 'react'
import CustomModal from '../../organisms/CustomModal'

interface ModalTimeoutProps {
  show: boolean
  onHide: () => void
  onContinue: () => void
}

const ModalTimeout = (props: ModalTimeoutProps): JSX.Element => {
  return (
    <CustomModal
      show={props.show}
      showClose={false}
      showFooter={true}
      onHide={props.onHide}
      title='Session Time Out'
      footerButtons={[
        {
          text: 'Continue',
          onClick: props.onContinue,
          variant: 'primary',
          outlined: false,
          testid: 'modal-timeout-continue-button'
        }
      ]}
    >
      <h2>Your session has timed out due to inactivity.</h2>
      <br />
      <h3>Please log back in to resume your session.</h3>
    </CustomModal>
  )
}

export default ModalTimeout
